import { render } from "./InfoReservation.vue?vue&type=template&id=350e5a76&scoped=true&ts=true"
import script from "./InfoReservation.vue?vue&type=script&lang=ts"
export * from "./InfoReservation.vue?vue&type=script&lang=ts"

import "./InfoReservation.vue?vue&type=style&index=0&id=350e5a76&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350e5a76"]])

export default __exports__